
















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import Collapsible from '@/components/layout/Collapse.vue'
import SelectYesOrNo from '@/survey/InterviewReportElements/SelectYesOrNo.vue'
import EditorMixin from '@/components/artifacts/EditorMixin'
import { IdObject } from '@/components/artifacts/module/types'

export default Vue.extend({
  props: ['interviewer', 'interviewee'],
  mixins: [EditorMixin],
  components: {
    SelectYesOrNo,
    Collapsible,
  },
  computed: {},
  created() {
    this.$store
      .dispatch({ type: 'interviewReports/pullObjects', where: null })
      .then((value: IdObject[]) => {
        console.log('zeig her', value)
        if (value.length > 0) {
          this.editCopy = value[0] as any
        }
      })
  },
  methods: {
    computeSuicideRisk(): void {
      const editCopy = (this as any).editCopy
      if (editCopy.suicidality_c1 || editCopy.suicidality_c2 || editCopy.suicidality_c6) {
        editCopy.suicidality_suicide_risk = 'low'
      }
      if (editCopy.suicidality_c3 || (editCopy.suicidality_c2 && editCopy.suicidality_c6)) {
        editCopy.suicidality_suicide_risk = 'middle'
      }
      if (
        editCopy.suicidality_c4 ||
        editCopy.suicidality_c5 ||
        (editCopy.suicidality_c3 && editCopy.suicidality_c6)
      ) {
        editCopy.suicidality_suicide_risk = 'high'
      }
    },

    computePTSDCriterionBFulfilled(): void {
      const ptsd = (this as any).editCopy
      ptsd.ptsd_b_fulfilled =
        ptsd.ptsd_b1 || ptsd.ptsd_b2 || ptsd.ptsd_b3 || ptsd.ptsd_b4 || ptsd.ptsd_b5
      this.computePTSDTotalFulfilled()
    },
    computePTSDCriterionCFulfilled(): void {
      const ptsd = (this as any).editCopy
      ptsd.ptsd_c_fulfilled = ptsd.ptsd_c1 || ptsd.ptsd_c1
      this.computePTSDTotalFulfilled()
    },
    computePTSDCriterionDFulfilled(): void {
      const ptsd = (this as any).editCopy
      let counter = 0
      if (ptsd.ptsd_d1) {
        counter = counter + 1
      }
      if (ptsd.ptsd_d2) {
        counter = counter + 1
      }
      if (ptsd.ptsd_d3) {
        counter = counter + 1
      }
      if (ptsd.ptsd_d4) {
        counter = counter + 1
      }
      if (ptsd.ptsd_d5) {
        counter = counter + 1
      }
      if (ptsd.ptsd_d6) {
        counter = counter + 1
      }
      if (ptsd.ptsd_d7) {
        counter = counter + 1
      }
      ptsd.ptsd_d_fulfilled = counter > 1

      this.computePTSDTotalFulfilled()
    },
    computePTSDCriterionEFulfilled(): void {
      const ptsd = (this as any).editCopy
      let counter = 0
      if (ptsd.ptsd_e1) {
        counter = counter + 1
      }
      if (ptsd.ptsd_e2) {
        counter = counter + 1
      }
      if (ptsd.ptsd_e3) {
        counter = counter + 1
      }
      if (ptsd.ptsd_e4) {
        counter = counter + 1
      }
      if (ptsd.ptsd_e5) {
        counter = counter + 1
      }
      if (ptsd.ptsd_e6) {
        counter = counter + 1
      }

      ptsd.ptsd_e_fulfilled = counter > 1
      this.computePTSDTotalFulfilled()
    },
    computePTSDTotalFulfilled(): void {
      const ptsd = (this as any).editCopy
      ptsd.ptsd_total_fulfilled =
        ptsd.ptsd_b_fulfilled &&
        ptsd.ptsd_c_fulfilled &&
        ptsd.ptsd_d_fulfilled &&
        ptsd.ptsd_e_fulfilled &&
        ptsd.ptsd_f_fulfilled &&
        ptsd.ptsd_g_fulfilled &&
        ptsd.ptsd_h_fulfilled
    },
    computeMDRCriterionAFulfilled(): void {
      const cmdrItems = (this as any).editCopy
      let counter = 0

      if (cmdrItems.cmdr_a1) {
        counter = counter + 1
      }
      if (cmdrItems.cmdr_a2) {
        counter = counter + 1
      }
      if (cmdrItems.cmdr_a3) {
        counter = counter + 1
      }
      if (cmdrItems.cmdr_a4) {
        counter = counter + 1
      }
      if (cmdrItems.cmdr_a5) {
        counter = counter + 1
      }
      if (cmdrItems.cmdr_a6) {
        counter = counter + 1
      }
      if (cmdrItems.cmdr_a7) {
        counter = counter + 1
      }
      if (cmdrItems.cmdr_a8) {
        counter = counter + 1
      }
      if (cmdrItems.cmdr_a9) {
        counter = counter + 1
      }

      cmdrItems.cmdr_a_fulfilled = (cmdrItems.cmdr_a1 || cmdrItems.cmdr_a2) && counter > 4
    },
    computeCurrentMajorDepressionFulfilled(): void {
      const cmdr = (this as any).editCopy
      cmdr.cmdr_mde_total_fulfilled =
        cmdr.cmdr_a_fulfilled && cmdr.cmdr_b_fulfilled && cmdr.cmdr_c_fulfilled
    },
    computeDysthymiaBFulfilled(): void {
      const pdd = (this as any).editCopy
      let counter = 0
      if (pdd.dysthymia_b1) {
        counter = counter + 1
      }
      if (pdd.dysthymia_b2) {
        counter = counter + 1
      }
      if (pdd.dysthymia_b3) {
        counter = counter + 1
      }
      if (pdd.dysthymia_b4) {
        counter = counter + 1
      }
      if (pdd.dysthymia_b5) {
        counter = counter + 1
      }
      if (pdd.dysthymia_b6) {
        counter = counter + 1
      }
      pdd.dysthymia_b_fulfilled = counter > 1
      this.computeDysthymiaTotalFulfilled()
    },
    computeDysthymiaTotalFulfilled(): void {
      const pdd = (this as any).editCopy
      pdd.dysthymia_total_fulfilled =
        pdd.dysthymia_a_fulfilled &&
        pdd.dysthymia_b_fulfilled &&
        pdd.dysthymia_c_fulfilled &&
        pdd.dysthymia_e_fulfilled &&
        pdd.dysthymia_f_fulfilled &&
        pdd.dysthymia_g_fulfilled &&
        pdd.dysthymia_h_fulfilled
    },
    saveeditCopys(): void {
      const self: any = this
      self.editCopy.interviewer_id = this.$store.getters.currentUserId
      self.editCopy.case_id = this.$store.getters.currentCaseId
      this.$emit('change', self.editCopy)
    },
  },
})
